module.exports = __webpack_public_path__ + "img/shipo-menu-vessel-line-up-white.726fd8b9.svg";